export default "__VITE_ASSET__XAaYkLUA__"